<div class="grid-section">
  <ng-container>
    <div style="padding-top: 16px">
      <ng-container *ngIf="!showGridPagination">
        <app-tpr-peers-grid
          [gridData]="gridData"
          [showAverage]="true"
          [showMedian]="true"
          orientation="grid"
          [visible]="isTabVisible"
          [containerClassName]="gridContainerClassName"
          [isDataInProgress]="isDataInProgress"
          sortByColumnId="marketCap"
          [currency]="meta ? meta.currency : ''"
          (onDeleteTicker)="handleOnDeleteTicker($event)"
          [currentTicker]="primaryTicker"
        ></app-tpr-peers-grid>
      </ng-container>
      <ng-container *ngIf="showGridPagination">
        <div class="grid-content">
          <app-tpr-peers-grid-v2
            *ngIf="showGridPagination"
            [gridData]="gridData"
            [showAverage]="true"
            [showMedian]="true"
            orientation="grid"
            [visible]="isTabVisible"
            [containerClassName]="gridContainerClassName"
            [isDataInProgress]="isDataInProgress"
            sortByColumnId="C2"
            [currency]="meta ? meta.currency : ''"
            (onDeleteTicker)="handleOnDeleteTicker($event)"
            [currentTicker]="primaryTicker"
          ></app-tpr-peers-grid-v2>
          <div *ngIf="isDataInProgress" class="grid-overlay-loader">
            <img
              class="grid-overlay-loader-img"
              alt="Loading"
              [src]="assets + '/spinner-blue.gif'"
              width="64"
              height="64"
            />
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
